import type { TZDate } from '@date-fns/tz';
import { type ReactNode, useState, useMemo, createContext } from 'react';

/** @internal */
type DayViewContextType = {
  setHoveredDate?: (date: TZDate | null) => void;
  hoveredDate?: TZDate | null;
};

/** @internal */
export const DayViewContext = createContext<DayViewContextType>({
  setHoveredDate: undefined,
  hoveredDate: null,
});

/** @internal */
export const DayViewContextProvider = ({
  children,
}: Readonly<{
  children: ReactNode;
}>) => {
  const [hoveredDate, setHoveredDate] = useState<TZDate | null>(null);
  const contextValue = useMemo(
    () => ({ hoveredDate, setHoveredDate }),
    [hoveredDate, setHoveredDate],
  );

  return (
    <DayViewContext.Provider value={contextValue}>
      {children}
    </DayViewContext.Provider>
  );
};
